import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React from "react";
import styles from "./styles/LandingFooter.module.css";

import celebrate from "../assets/images/image-6.png";
import Slider from "react-slick";
import "./styles/carousel.css";
import news_poster1 from "../assets/images/news/news_1.png";
import news_poster2 from "../assets/images/news/news_2.png";
import news_poster3 from "../assets/images/news/news_3.png";
import news_poster4 from "../assets/images/news/news_4.png";
import { NavLink } from "react-router-dom";
export const FooterCarousel = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    prevArrow: (
      <div>
        <div className="next-slick-arrow">
          {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="34"
            viewBox="0 0 20 34"
            fill="none"
          >
            <path
              d="M17 3L3 17L17 31"
              stroke="#013582"
              stroke-width="6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>{" "}
        </div>
      </div>
    ),
    nextArrow: (
      <div>
        <div className="prev-slick-arrow">
          {" "}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="34"
            viewBox="0 0 20 34"
            fill="none"
          >
            <path
              d="M3 3L17 17L3 31"
              stroke="#013582"
              stroke-width="6"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>{" "}
        </div>
      </div>
    ),
  };
  const carouselData = [
    {
      alt: "The Luxury Chronicle article",
      img: news_poster1,
      link: "https://www.theluxurychronicle.com/india-disruptor-alert-in-digital-entertainment-halliv-brings-groundbreaking-tech-for-content-creators-and-consumers/",
    },
    // {
    //   alt: "Ani article",
    //   img: news_poster2,
    //   link: "https://aninews.in/news/business/business/new-tech-platform-halliv-gaining-popularity-with-digital-entertainment-creators20230925132603/",
    // },
    {
      alt: "Zee5 Article",
      img: news_poster4,
      link: "https://www.zee5.com/articles/new-tech-platform-halliv-gaining-popularity-with-digital-entertainment-creators",
    },
    {
      alt: "Marksmen Daily Article",
      img: news_poster3,
      link: "https://marksmendaily.com/2023/09/25/new-tech-platform-halliv-gaining-popularity-with-digital-entertainment-creators/",
    },
  ];
  return (
    <div className={styles.footer_carousel}>
      <div>
        <div className={styles.footer_carousel_text}>We are in news!</div>
        <img src={celebrate} alt="" />
      </div>
      <div className={styles.carousel_box}>
        <Slider {...settings}>
          {carouselData?.map((el, i) => {
            return (
              <div className={styles.carousel_slides} key={i}>
                <NavLink
                  to={el.link}
                  target="_blank"
                  style={{
                    display: "inline-block",
                    width: "auto", // Set the width to "auto" to match the image's width
                    height: "auto",
                  }}
                >
                  <img
                    src={el?.img}
                    alt={el?.alt}
                    style={{ cursor: "pointer" }}
                  />
                </NavLink>
              </div>
            );
          })}
        </Slider>
      </div>
    </div>
  );
};
